import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    templateUrl: './inventory-datatable-update.component.html',
    styleUrls: ['./inventory-datatable-update.component.scss'],
})
export class InventoryUpdateStockModal {
    @Input() productName: string = 'Initial name';
    @Input() currentStock: number = 20000;

    @Output() updateEvent = new EventEmitter<number>();

    newStock: number;
    difference: number = 0;

    constructor(public modalRef: BsModalRef) {}

    updateDifference(): void {
        const newStockValue = Number(this.newStock);
        if (!isNaN(newStockValue)) {
            this.difference = newStockValue - this.currentStock;
        } else {
            this.difference = 0;
        }
    }

    update(): void {
        this.updateEvent.emit(this.newStock);
    }
}
